import React from 'react'
import styled from 'styled-components'
import { SkeletonLine, SkeletonBlock, SkeletonRows } from 'components/Skeleton'

const PassportDetailSkeleton = ({ ariaLabel = 'Loading' }) => (
  <Wrap aria-busy='true' aria-label={ariaLabel}>
    <SkeletonLine $w='180px' $h={13} />

    <Card>
      <Identity>
        <SkeletonBlock $w='48px' $h={48} $r='13px' />
        <Stack>
          <SkeletonLine $w='120px' $h={11} />
          <SkeletonLine $w='260px' $h={28} />
        </Stack>
        <Actions>
          <SkeletonBlock $w='104px' $h={32} $r='999px' />
          <SkeletonBlock $w='74px' $h={32} $r='999px' />
          <SkeletonBlock $w='74px' $h={32} $r='999px' />
        </Actions>
      </Identity>
    </Card>

    <Card>
      <Tabs>
        {[92, 74, 82, 108, 96, 70].map((w, i) => (
          <SkeletonLine key={i} $w={`${w}px`} $h={14} />
        ))}
      </Tabs>
      <Rule />
      <Body>
        <SkeletonLine $w='220px' $h={22} />
        <SkeletonRows rows={6} />
      </Body>
    </Card>
  </Wrap>
)

export default PassportDetailSkeleton

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding-top: 8px;
`

const Card = styled.div`
  box-sizing: border-box;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid rgba(12, 18, 41, 0.08);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(12, 18, 41, 0.04);
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 18px;

  @media (max-width: 768px) {
    padding: 16px;
  }
`

const Identity = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`

const Actions = styled.div`
  display: inline-flex;
  gap: 8px;
  margin-left: auto;
`

const Rule = styled.div`
  height: 1px;
  background: rgba(12, 18, 41, 0.08);
`


const Tabs = styled.div`
  display: flex;
  gap: 22px;
  padding: 6px 0 12px;
  overflow: hidden;
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding-top: 6px;
`
